"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const react_i18next_1 = require("react-i18next");
const icons_1 = require("../../atoms/icons");
const typography_1 = require("../../shared/typography");
exports.default = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { children: [(0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangleSmall", icon: ["fal", "wifi-slash"], size: "xs" }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { children: t("offlineBar.notification") }, void 0)] }, void 0));
};
const Wrapper = styled_components_1.default.div `
  background: ${({ theme }) => theme.colors.yellowBase};
  display: flex;
  align-items: center;
  height: 100%;
  padding: ${({ theme }) => theme.spacings.m};

  p {
    color: ${({ theme }) => theme.colors.greyBase};
    font-size: 0.75rem;
    margin-bottom: 0;
    margin-left: ${({ theme }) => theme.spacings.s};
  }
`;
//# sourceMappingURL=OfflineNotification.js.map